<section class="md-page">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

  <div class="card md-form-shell">
    <div class="card-container bg-gray-100 border-round mt-2 p-4">
      <div class="mr-5 flex align-items-center justify-content-between mb-3">
        <div class="flex align-items-center">
          <i class="pi pi-sitemap mr-2 text-3xl"></i>
          <div class="font-medium text-3xl text-900">Business Units</div>
        </div>

        <div class="flex gap-2">
          <p-button
            label="New Business Unit"
            icon="pi pi-plus"
            (onClick)="createBusinessUnit()"
          ></p-button>
          <p-button
            label="Export"
            icon="pi pi-file-excel"
            styleClass="p-button-help"
            (click)="exportExcel()"
          ></p-button>
        </div>
      </div>

      <p-table
        #dt
        [value]="businessUnits"
        [rows]="10"
        [totalRecords]="totalRecords"
        [paginator]="true"
        [loading]="isLoading"
        [lazy]="true"
        (onLazyLoad)="loadBusinessUnits($event)"
        dataKey="id"
        styleClass="p-datatable-striped md-data-table"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="businessUnitName">
              Business Unit Name <p-sortIcon field="businessUnitName"></p-sortIcon>
            </th>
            <th pSortableColumn="businessUnitCode">
              Business Unit Code <p-sortIcon field="businessUnitCode"></p-sortIcon>
            </th>
            <th>AR Account</th>
            <th>AP Account</th>
            <th>Reference</th>
            <th style="width: 10rem">Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-businessUnit>
          <tr>
            <td>{{ businessUnit.businessUnitName }}</td>
            <td>{{ businessUnit.businessUnitCode ?? null }}</td>
            <td>{{ businessUnit.arAccount ?? null }}</td>
            <td>{{ businessUnit.apAccount ?? null }}</td>
            <td>{{ businessUnit.reference ?? null }}</td>
            <td>
              <div class="flex gap-2">
                <p-button
                  icon="pi pi-pencil"
                  styleClass="p-button-rounded p-button-success"
                  (onClick)="editBusinessUnit(businessUnit.id)"
                ></p-button>
                <p-button
                  icon="pi pi-trash"
                  styleClass="p-button-rounded p-button-danger"
                  (onClick)="deleteBusinessUnit(businessUnit.id)"
                ></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6">No Business Units found.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</section>
